/**
 * Detects a `WORKFLOW_RUN_FETCH_FAILED` rejection carrying a `404` — the one status the screens that read
 * a preparation render as « introuvable », never as the generic error state.
 */
const isWorkflowRunNotFoundFailure = (candidate: unknown): boolean => {
	if (typeof candidate !== 'object' || candidate === null) {
		return false;
	}

	const action = candidate as { type?: unknown; payload?: { status?: unknown } };

	return action.type === 'WORKFLOW_RUN_FETCH_FAILED' && action.payload?.status === 404;
};

export default isWorkflowRunNotFoundFailure;
